// extracted by mini-css-extract-plugin
export default {"policy":"sZvhxTltMImZqIkDgWX4"};